import { STATS } from "@/content/galaxy";

export const StatsStrip = () => {
  return (
    <div
      data-testid="hero-stats-strip"
      className="glass-sheen mt-10 overflow-hidden rounded-2xl border border-white/15 glass"
    >
      <div className="grid grid-cols-2 sm:grid-cols-4">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            data-testid={`hero-stat-${i}`}
            className={
              "group px-5 py-4 transition-colors duration-200 hover:bg-white/5 " +
              (i % 2 === 1 ? "border-l border-white/10 " : "") +
              (i >= 2 ? "border-t border-white/10 sm:border-t-0 " : "") +
              (i >= 1 ? "sm:border-l sm:border-white/10" : "")
            }
          >
            <div className="font-display text-lg font-extrabold tracking-wide text-white transition-colors duration-200 group-hover:text-gl-blue2 sm:text-xl">
              {s.value}
            </div>
            <div className="mt-1 text-[11px] tracking-[0.18em] text-white/55">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
